import { render, staticRenderFns } from "./PDFH5Viewer.vue?vue&type=template&id=07f56449&"
import script from "./PDFH5Viewer.vue?vue&type=script&lang=js&"
export * from "./PDFH5Viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports